import type { IChatMessage } from '@kognitos/lattice';

import { getTimestamp } from '@/shared/utils/datetime-utils';

/**
 * Wall clock across a run of work, from the rows that carry a usable start time.
 *
 * A row's timestamp is when it started, so a run needs two distinct stamps to
 * span anything; a single row would otherwise read as "< 1s" for work that took
 * far longer. Unstamped rows are skipped rather than voiding the span.
 *
 * @param rows The run's rows.
 * @returns The span in milliseconds, or `undefined` when there is nothing to measure.
 */
export function workRunSpanMs(
  rows: readonly IChatMessage[],
): number | undefined {
  const stampedAt = rows
    .map(row => getTimestamp(row.timestamp))
    .filter(at => at > 0);
  if (stampedAt.length < 2) return undefined;
  const span = Math.max(...stampedAt) - Math.min(...stampedAt);
  return span > 0 ? span : undefined;
}
